import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { ShipDeliService } from '../../../service/ship-deli/ship-deli.service';
import { ShipInvoiceService } from '../../../service/ship-invoice/ship-invoice.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { isAuthority } from '../../../util/util';
import * as moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: 'wa3050.component.html',
  styleUrls: ['wa3050.component.scss']
})
export class Wa3050Component implements AfterViewInit {
  public componentTitle = 'WA3050:荷札出力（ケース成りピック）';

  public owners: any;
  public ownerId: number;

  @ViewChild('picknoCdElement') picknoCdElement: ElementRef;

  public log1Tx: string = '';
  public log2Tx: string = '';

  // 印刷設定
  // 荷札
  private printagentCd_rc0211 = 'PA0001';
  private printerCd_rc0211 = '';
  // 納品書
  private printagentCd_ra3008 = 'PA0001';
  private printerCd_ra3008 = '';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public picknoCd = new FormControl('', [Validators.required, Validators.maxLength(validation.picknoCd.maxLength)]);
  // build FormGroup
  myForm = this.builder.group({
    picknoCd: this.picknoCd
  });

  // Authorith
  public disableF999 = isAuthority('wa3050', 'F999');

  private errorInfo = '';

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private shipDeliService: ShipDeliService,
    private shipInvoiceService: ShipInvoiceService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    // 印刷設定取得
    if (localStorage.getItem(`printagentCd_rc0211`) !== null && localStorage.getItem(`printagentCd_rc0211`) !== '') {
      this.printagentCd_rc0211 = localStorage.getItem(`printagentCd_rc0211`);
    }
    if (localStorage.getItem(`printerCd_rc0211`) !== null && localStorage.getItem(`printerCd_rc0211`) !== '') {
      this.printerCd_rc0211 = localStorage.getItem(`printerCd_rc0211`);
    }
    if (localStorage.getItem(`printagentCd_ra3008`) !== null && localStorage.getItem(`printagentCd_ra3008`) !== '') {
      this.printagentCd_ra3008 = localStorage.getItem(`printagentCd_ra3008`);
    }
    if (localStorage.getItem(`printerCd_ra3008`) !== null && localStorage.getItem(`printerCd_ra3008`) !== '') {
      this.printerCd_ra3008 = localStorage.getItem(`printerCd_ra3008`);
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      //this.picknoCdElement.nativeElement.focus();
      this.onView();
    }, 500);
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onChangePicknoCd(event: any) {
    this.execute();
  }

  execute() {
    // 二重入力を防ぐため入力欄を無効化
    this.picknoCd.disable();
    this.working = true;
    // バリデーション
    this.picknoCd.markAsTouched();
    if (this.picknoCd.invalid) {
      this.picknoCd.enable();
      this.working = false;
      this.picknoCdElement.nativeElement.select();
      return;
    }
    // 前回ログ削除
    this.clearLog();
    // 荷札初回出力
    this.shipDeliService
      .printByPick(
        this.printagentCd_rc0211
        , this.printerCd_rc0211
        , this.picknoCd.value.toUpperCase()
        , null
        , 0
        , 'wa3050')
      .then(outputJson => {
        console.log(outputJson);
        if (outputJson.printedFl === 0) {
          // 荷札初回出力が正常に完了
          this.log1Tx = moment(new Date()).format('HH:mm:ss') + ' ピック番号=[' + this.picknoCd.value + '] 荷札出力枚数=[' + outputJson.printdeliNr + ']';
          this.log2Tx = '';
          // 納品書出力
          this.shipInvoiceService
            .printByPick(this.printagentCd_ra3008, this.printerCd_ra3008, this.picknoCd.value.toUpperCase(), null, 1, 'wa3050')
            .then(outputJson => {
              // 納品書出力が正常に完了
              this.log2Tx = moment(new Date()).format('HH:mm:ss') + ' ピック番号=[' + this.picknoCd.value + '] 納品書出力枚数=[' + outputJson.printinvoiceNr + ']';
              this.picknoCd.enable();
              this.working = false;
              this.picknoCdElement.nativeElement.select();
            })
            .catch(error => {
              // 納品書出力がエラー
              console.log(this.commonService.getErrorMessage(error));
              this.log1Tx = moment(new Date()).format('HH:mm:ss') + ' ピック番号=[' + this.picknoCd.value + ']';
              this.log2Tx = this.commonService.getErrorMessage(error);
              this.picknoCd.enable();
              this.working = false;
              this.picknoCdElement.nativeElement.select();
            });
        } else {
          // 荷札出力済みの場合
          if (!this.disableF999) {
            // 再出力不可
            this.log1Tx = moment(new Date()).format('HH:mm:ss') + ' ピック番号=[' + this.picknoCd.value + ']';
            this.log2Tx = '出力済みです（権限不足のため再出力できません）。';
            this.picknoCd.enable();
            this.working = false;
            this.picknoCdElement.nativeElement.select();
          } else {
            // 再出力可
            this.dialogsService.confirm('確認', '出力済みですが、再出力してよろしいですか？').subscribe(res => {
              if (res === true) {
                // 荷札を再出力する
                this.working = true;
                this.shipDeliService
                  .printByPick(
                    this.printagentCd_rc0211
                    , this.printerCd_rc0211
                    , this.picknoCd.value.toUpperCase()
                    , null
                    , 0
                    , 'wa3050')
                  .then(outputJson => {
                    // 荷札再出力が正常に完了
                    // 納品書は再出力しない
                    this.log1Tx = moment(new Date()).format('HH:mm:ss') + ' ピック番号=[' + this.picknoCd.value + '] 荷札出力枚数=[' + outputJson.printdeliNr + ']';
                    this.log2Tx = '';

                    // 納品書出力
                    this.shipInvoiceService
                      .printByPick(
                        this.printagentCd_ra3008,
                        this.printerCd_ra3008,
                        this.picknoCd.value.toUpperCase(),
                        null,
                        1,
                        "wa3050"
                      )
                      .then(outputJson => {
                        // 納品書出力が正常に完了
                        this.log2Tx = moment(new Date).format("HH:mm:ss") + " ピック番号=[" + this.picknoCd.value + "] 納品書出力枚数=[" + outputJson.printinvoiceNr + "]";
                        this.picknoCd.enable();
                        this.working = false;
                        this.picknoCdElement.nativeElement.select();
                      })
                      .catch(error => {
                        // 納品書出力がエラー
                        console.log(this.commonService.getErrorMessage(error));
                        this.log1Tx = moment(new Date).format("HH:mm:ss") + " ピック番号=[" + this.picknoCd.value + "]";
                        this.log2Tx = this.commonService.getErrorMessage(error);
                        this.picknoCd.enable();
                        this.working = false;
                        this.picknoCdElement.nativeElement.select();
                      })
                  })
                  .catch(error => {
                    // 荷札再出力がエラー
                    this.working = false;
                    console.log(this.commonService.getErrorMessage(error));
                    this.log1Tx = moment(new Date()).format('HH:mm:ss') + ' ピック番号=[' + this.picknoCd.value + ']';
                    this.log2Tx = this.commonService.getErrorMessage(error);
                    this.picknoCd.enable();
                    this.working = false;
                    this.picknoCdElement.nativeElement.select();
                  });
              } else {
                // 荷札を再出力しない
                this.picknoCd.enable();
                this.working = false;
                this.picknoCdElement.nativeElement.select();
              }
            });
          }
        }
      })
      .catch(error => {
        // 荷札初回出力がエラー
        console.log(this.commonService.getErrorMessage(error));
        this.log1Tx = moment(new Date()).format('HH:mm:ss') + ' ピック番号=[' + this.picknoCd.value + ']';
        this.log2Tx = this.commonService.getErrorMessage(error);
        this.picknoCd.enable();
        this.working = false;
        this.picknoCdElement.nativeElement.focus();
        this.picknoCdElement.nativeElement.select();
      });
  }

  initPicknoCd() {
    this.picknoCd.enable();
    this.picknoCd.setValue('');
    this.picknoCd.markAsUntouched();
  }

  clearLog() {
    this.log1Tx = '';
    this.log2Tx = '';
    this.working = false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3050/wa3050.component.ts